(() => {
  if (customElements.get('dollop-base-option')) return;
  class DollopBaseOption extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);
      this.classList.add('is-ready');
      this.sync();
      // Shopify morphs the picker after a variant response; keep the checkbox in sync.
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['selected'] });
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.observer?.disconnect();
    }
    sync() {
      const select = this.querySelector('select');
      const checkbox = this.querySelector('[data-base-checkbox]');
      if (select && checkbox) checkbox.checked = select.value === 'With base';
    }
    onChange = (event) => {
      if (!event.target.matches('[data-base-checkbox]')) return;
      // Send the native Shopify select event, never a cosmetic cart surcharge.
      event.stopPropagation();
      const select = this.querySelector('select');
      select.value = event.target.checked ? 'With base' : 'Without base';
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
  }
  customElements.define('dollop-base-option', DollopBaseOption);
})();
